import React, { useCallback } from 'react';
import Grid from '@mui/material/Grid2';
import TextField from '@mui/material/TextField';
import { Equation } from '@/__generated__/graphql';
import { keyFromTitle } from '../../../utils';

interface EquationFormProps {
  equation: Equation;
  mode: 'ReadOnly' | 'Edit';
  isNewEquation: boolean;
  onUpdate: (updates: Partial<Equation>) => void;
}

export const EquationForm = React.memo(
  ({ equation, mode, isNewEquation, onUpdate }: EquationFormProps) => {
    const handleNameChange = useCallback(
      (newName: string) => {
        const updates: Partial<Equation> = { name: newName };

        if (isNewEquation) {
          updates.key = keyFromTitle(newName);
        }

        onUpdate(updates);
      },
      [isNewEquation, onUpdate]
    );

    return (
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, md: 6 }}>
          <TextField
            fullWidth
            label="Equation Name"
            value={equation.name ?? ''}
            onChange={(e) => handleNameChange(e.target.value)}
            disabled={mode === 'ReadOnly'}
          />
        </Grid>

        <Grid size={{ xs: 12, md: 6 }}>
          <TextField
            fullWidth
            label="Equation Key"
            value={equation.key ?? ''}
            disabled
            helperText={
              isNewEquation
                ? 'Auto-generated from equation name'
                : 'Existing equation key (read-only)'
            }
          />
        </Grid>
      </Grid>
    );
  }
);
